export const queryParams = {
  magicToken: "magic_link_token",
  products: "products",
  bookingId: "booking_id",
  caseId: "case_id",
} as const;
